const cache = new Map<string, Promise<any>>();

export const fetchWithCache = <T>(
  key: string,
  fetcher: () => Promise<T>,
  forceRefresh = false
): Promise<T> => {
  if (!forceRefresh && cache.has(key)) {
    return cache.get(key) as Promise<T>;
  }

  const promise = fetcher();
  cache.set(key, promise);

  promise.catch(() => {
    if (cache.get(key) === promise) {
      cache.delete(key);
    }
  });

  return promise;
};

export const clearApiCache = (key?: string): void => {
  if (key) {
    cache.delete(key);
    return;
  }
  cache.clear();
};
